import Select from '@/components/form/Select';
import TimePicker from '@/components/form/TimePicker';
import LocationsFieldArray from './LocationsFieldArray';
import { COACH_ACTIVITY_STATUS } from '@/app/coachActivity/enums';
import { useCoachActivities } from '@/data/coachActivity';

const FormGeneral = () => {
  const coachActivities = useCoachActivities();

  return (
    <div className="space-y-4">
      <Select
        name="coachActivityId"
        label="Activity"
        options={
          coachActivities.data
            ?.filter((ca) => ca.status === COACH_ACTIVITY_STATUS.APPROVED)
            .map((coachActivity) => ({
              value: coachActivity.id,
              label: coachActivity.activity.title
            })) || []
        }
      />
      <TimePicker name="startTime" label="Start Time" />
      <TimePicker name="endTime" label="End Time" />
      <div className="pt-2">
        <LocationsFieldArray />
      </div>
    </div>
  );
};

export default FormGeneral;
